import { render, staticRenderFns } from "./ServidorForm.vue?vue&type=template&id=741595ba&"
import script from "./ServidorForm.vue?vue&type=script&lang=js&"
export * from "./ServidorForm.vue?vue&type=script&lang=js&"
import style0 from "./ServidorForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports